<template>
  <div class="complete-registration">
    <v-row align="center">
      <v-col class="text-center">
        <v-img src="../assets/2025-home-header.png" />
      </v-col>
    </v-row>
    <v-row class="mt-5">
      <v-col class="text-center">
        <heart-loader />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import HeartLoader from '../components/HeartLoader.vue'

export default {
  name: 'Cancel',

  components: {
    HeartLoader,
  },

  data() {
    return {
      checkoutLink: null,
    }
  },

  computed: {
  },

  methods: {
    async patchMemberHasPaid() {
      await this.$store.dispatch('patchMemberHasPaid', this.$store.state.member.id)
        .then((res) => {
          if (res) {
            this.$router.push({ name: 'LeaderboardRoute' })
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },

  async beforeMount() {
    await this.patchMemberHasPaid()
  }


}
</script>

<style lang="scss">

</style>